import React from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';

import FeatureList from '../../components/products/FeatureList';
import GetStarted from '../../components/products/GetStarted';
import Header from '../../components/header';
import PaymentMethods from '../../components/products/events/PaymentMethods';
import ProductFeature from '../../components/products/events/ProductFeature';
import ProductIntroduce from '../../components/products/events/ProductIntroduce';
import RegistrationAndTicketing from '../../components/products/events/RegistrationAndTicketing';
import SectionWrapper from '../../components/products/events/SectionWrapper';

import Advantage01_1x from '../../images/products/events/new/Advantage01@1x.png';
import Advantage01_2x from '../../images/products/events/new/Advantage01@2x.png';
import Advantage01_3x from '../../images/products/events/new/Advantage01@3x.png';
import Advantage02_1x from '../../images/products/events/new/Advantage02@1x.png';
import Advantage02_2x from '../../images/products/events/new/Advantage02@2x.png';
import Advantage02_3x from '../../images/products/events/new/Advantage02@3x.png';
import Advantage03_1x from '../../images/products/events/new/Advantage03@1x.png';
import Advantage03_2x from '../../images/products/events/new/Advantage03@2x.png';
import Advantage03_3x from '../../images/products/events/new/Advantage03@3x.png';
import Advantage04_1x from '../../images/products/events/new/Advantage04@1x.png';
import Advantage04_2x from '../../images/products/events/new/Advantage04@2x.png';
import Advantage04_3x from '../../images/products/events/new/Advantage04@3x.png';
import Advantage05_1x from '../../images/products/events/new/Advantage05@1x.png';
import Advantage05_2x from '../../images/products/events/new/Advantage05@2x.png';
import Advantage05_3x from '../../images/products/events/new/Advantage05@3x.png';
import EventPagePictureSVG from '../../images/products/events/new/EventPagePicture.svg';
import Feature01 from '../../images/products/Feature01.svg';
import Feature02 from '../../images/products/Feature02.svg';
import HeroPictureSVG from '../../images/products/events/new/HeroPicture.svg';
import Slide01_1x from '../../images/products/events/new/Slide01@1x.png';
import Slide01_2x from '../../images/products/events/new/Slide01@2x.png';
import Slide01_3x from '../../images/products/events/new/Slide01@3x.png';
import Slide02_1x from '../../images/products/events/new/Slide02@1x.png';
import Slide02_2x from '../../images/products/events/new/Slide02@2x.png';
import Slide02_3x from '../../images/products/events/new/Slide02@3x.png';
import Slide03_1x from '../../images/products/events/new/Slide03@1x.png';
import Slide03_2x from '../../images/products/events/new/Slide03@2x.png';
import Slide03_3x from '../../images/products/events/new/Slide03@3x.png';

// old engagement stuff
import dragAndDropEmailImg from '../../images/products/engagement/drag_and_drop_email.png';
import dragAndDropEmailImg2X from '../../images/products/engagement/drag_and_drop_email@2x.png';
import dragAndDropEmailImg3X from '../../images/products/engagement/drag_and_drop_email@3x.png';

import statisticsImg from '../../images/products/engagement/statistics_img.png';
import statisticsImg2X from '../../images/products/engagement/statistics_img@2x.png';
import statisticsImg3X from '../../images/products/engagement/statistics_img@3x.png';

import dragAndDropFormImg from '../../images/products/engagement/drag_and_drop_form.png';
import dragAndDropFormImg2X from '../../images/products/engagement/drag_and_drop_form@2x.png';
import dragAndDropFormImg3X from '../../images/products/engagement/drag_and_drop_form@3x.png';

import mblApplicationImg from '../../images/products/engagement/mbl_application.png';
import mblApplicationImg2X from '../../images/products/engagement/mbl_application@2x.png';
import mblApplicationImg3X from '../../images/products/engagement/mbl_application@3x.png';

import appleStoreSvg from '../../images/products/engagement/apple_store.svg';

import googleStoreImg from '../../images/products/engagement/google_store.jpg';
import googleStoreImg2X from '../../images/products/engagement/google_store@2x.jpg';
import googleStoreImg3X from '../../images/products/engagement/google_store@3x.jpg';

import { translate } from '../../../i18n';

import { LinkButton } from '../../components/commons';

const t = translate('pages/products/events');

const { GATSBY_MANAGER_URL, GATSBY_FRONTEND_URL } = process.env;

const Wrapper = styled.div`
  overflow-x: hidden;
`;

const ProductDescription = styled.div`
  font-size: 12px;
  line-height: 1.6;
  width: ${ ({ widthMob }) => widthMob || '50%' };
  margin: 10px auto 30px;
  text-align: center;

  @media (min-width: 901px) {
    width: ${ ({ width }) => width || '75%' };
    font-size: 15px;
    margin: 20px auto 30px;
  }

  &::after {
    width: 100%;
    height: 100%;
    content: ${ ({ description }) => `"${ description }"` };

    @media (max-width: 900px) {
      content: ${ ({ description, descriptionMob }) =>
        `"${ descriptionMob || description }"` };
    }
  }
`;

const SectionHeading = styled.h2`
  text-align: center;
  font-size: 25px;
  line-height: 1.2;
  font-weight: bold;
  margin: 0 auto;
  width: 100%;
  padding-bottom: ${ props =>
    props.paddingBottom ? `${ props.paddingBottom }px` : '20px' };
  text-transform: none;

  @media (max-width: 900px) {
    font-size: ${ props =>
      props.fontSizeMob ? `${ props.fontSizeMob }px` : '25px' };
    width: 80%;
    padding-bottom: ${ props =>
      props.paddingBottomMob ? `${ props.paddingBottomMob }px` : '20px' };
    line-height: 1.5;
  }
`;

const Button = styled.a`
  display: block;
  padding: 12px 30px;
  font-size: 15px;
  font-weight: bold;
  line-height: 1.2;
  background-color: ${ ({ inverted }) => (inverted ? '#00a7ff' : '#fff') };
  color: ${ ({ inverted }) => (inverted ? '#fff' : '#00a7ff') };
  border-radius: 1000px;
  cursor: pointer;
  transition: all 0.2s;
  width: fit-content;
  ${ ({ margin }) => margin && `margin: ${ margin };` };

  &:hover {
    color: ${ ({ inverted }) => (inverted ? '#00a7ff' : '#fff') };
    background-color: ${ ({ inverted }) => (inverted ? '#fff' : '#00a7ff') };
  }

  @media (max-width: 900px) {
    ${ ({ marginMob }) => marginMob && `margin: ${ marginMob };` };
  }

  ${ ({ hideOnSmallScreen }) =>
    hideOnSmallScreen && '@media (max-width: 900px) { display: none; }' };

  ${ ({ hideOnLargeScreen }) =>
    hideOnLargeScreen && '@media (min-width: 901px) { display: none; }' };
`;

const HeroWrapper = styled.div`
  background-image: linear-gradient(to top, #ffffff, #16c89f);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 85px;
  flex-direction: column;

  @media (max-width: 900px) {
    padding-bottom: 70px;
    padding-top: 105px;
  }
`;

const HeroIcon = styled.img`
  margin-bottom: 10px;
  width: 60px;
  height: 60px;
`;

const HeroHeading = styled.h1`
  color: #fff;
  font-size: 45px;
  line-height: 1.25;
  text-align: center;
  font-weight: bold;
  margin-bottom: 10px;
  width: 925px;
  text-transform: none;

  @media (max-width: 900px) {
    font-size: 25px;
    line-height: 1.2;
    width: 90%;
  }
`;

const HeroSubHeading = styled.h2`
  color: #fff;
  font-size: 25px;
  line-height: 1.4;
  text-align: center;
  font-weight: normal;
  margin-bottom: 42px;
  width: 720px;
  text-transform: none;

  @media (max-width: 900px) {
    font-size: 15px;
    line-height: 1.4;
    width: unset;
  }
`;

const HeroPicture = styled.img`
  display: block;
  margin-top: 70px;

  @media (max-width: 900px) {
    width: 150%;
    margin-top: 60px;
  }
`;

const EventPagePicture = styled.img`
  width: 80px;
  height: 80px;
  margin: 0 auto 30px;
  display: block;

  @media (max-width: 900px) {
    width: 60px;
    height: 60px;
  }
`;

const Oval = styled.div`
  width: ${ ({ width }) => width };
  height: ${ ({ height }) => height };
  background: ${ ({ color }) => color };
  position: absolute;
  border-radius: 100%;
  ${ ({ top }) => top && `top: ${ top }` };
  ${ ({ bottom }) => bottom && `bottom: ${ bottom }` };
  ${ ({ left }) => left && `left: ${ left }` };
  ${ ({ right }) => right && `right: ${ right }` };

  @media (max-width: 900px) {
    display: none;
  }
`;

const SliderContainer = styled.div`
  transform: translateX(calc((100% - 100vw) / 2));
  margin-bottom: 20px;

  ${ ({ hideOnSmallScreen }) =>
    hideOnSmallScreen && '@media (max-width: 900px) { display: none; }' };
  ${ ({ hideOnLargeScreen }) =>
    hideOnLargeScreen && '@media (min-width: 901px) { display: none; }' };
`;

// old engagement stuff
const MblAppIconContainer = styled.div`
  display: flex;
  padding-top: 30px;

  @media (max-width: 900px) {
    justify-content: center;
  }
`;

const MblAppIconWrapper = styled.a`
  padding-right: 20px;
`;

const Image = styled.img`
  max-width: 100%;
`;

const AppImage = styled(Image)`
  max-height: 46px;
  height: 46px;
`;

const FeatureListData = [
  {
    picture: Feature01,
    heading: 'Membership',
    description:
      'Customize your membership system, turn your contacts into members, and reward members with privileges and benefits.',
    url: '/products/membership'
  },
];

export default () => (
  <Wrapper>
    <Helmet title={ t('Event Creation and Ticketing | Juven') }>
      <meta
        name='description'
        content={ t(
          'Looking a better way to create events? Juven helps event organizations run recurring events, multi-session ticketing, and customizable event pages. Start for free!'
        ) }
      />
    </Helmet>

    <Header
      desktopNotFixed
      mobileHidden={ false }
      navigationBarNotFixed
      showLanguage
    />

    <HeroWrapper>
      <HeroIcon alt='' src={ Feature02 } />

      <HeroHeading>
        { t('Powerful, intelligent and feature-rich tools for event management') }
      </HeroHeading>

      <HeroSubHeading>
        { t('Save time, increase productivity and resolve ticketing issues') }
      </HeroSubHeading>

      <LinkButton
        href={ `${ GATSBY_MANAGER_URL }/signup` }
        text={ t('Try it today') }
        id='events_top_banner_cta'
      />

      <HeroPicture
        alt={ t(
          'Powerful, intelligent and feature-rich tools for event management'
        ) }
        src={ HeroPictureSVG }
      />
    </HeroWrapper>

    <SectionWrapper
      paddingTop='120'
      paddingBottom='90'
      customPaddingBottom='90'
      paddingBottomMob='90'
      paddingTopMob='30'
    >
      <ProductIntroduce
        title={ t('Events are simple and easy to create') }
        fontSizeWeb='25'
        fontSizeMob='20'
      />

      <RegistrationAndTicketing
        title={ `${ t('Highly flexible ticketing setting') }` }
        descriptionLineHeight='1.6'
        descriptionInMid
        marginTop='90'
        marginTopMob='30'
        alignRight
        noExtraMarginTop
        contentMarginTop='10'
        headingMarginBottom='10'
        descriptionFontSize='12'
        imgSrc={ Advantage01_1x }
        srcSet={ `${ Advantage01_1x } 1x, ${ Advantage01_2x } 2x, ${ Advantage01_3x } 3x` }
        description={ t(
          'Unique for event organizations, you can set exclusive event ticket types and dates. You can also set different promotional codes and ticketing packages.'
        ) }
      />

      <RegistrationAndTicketing
        title={ `${ t('Multi-sessions ticketing') }` }
        descriptionLineHeight='1.6'
        descriptionInMid
        marginTopMob='90'
        alignLeft
        imgOnLeft
        noExtraMarginTop
        contentMarginTop='10'
        headingMarginBottom='10'
        descriptionFontSize='12'
        imgSrc={ Advantage02_1x }
        srcSet={ `${ Advantage02_1x } 1x, ${ Advantage02_2x } 2x, ${ Advantage02_3x } 3x` }
        description={ t(
          'Automate your team’s repetitive work. You can set events to repeat daily, weekly or monthly, over a period in a single keystroke.'
        ) }
      />

      <RegistrationAndTicketing
        title={ `${ t('Mobile responsive event ticketing page') }` }
        descriptionLineHeight='1.6'
        descriptionInMid
        marginTop='40'
        marginTopMob='90'
        alignRight
        noExtraMarginTop
        contentMarginTop='10'
        headingMarginBottom='10'
        descriptionFontSize='12'
        imgSrc={ Advantage03_1x }
        srcSet={ `${ Advantage03_1x } 1x, ${ Advantage03_2x } 2x, ${ Advantage03_3x } 3x` }
        description={ t(
          'Our ticketing page can be accessed online at any time from any device in any browser. Our manager app and user app to support everything you need in event organization and ticketing management.'
        ) }
      />

      <RegistrationAndTicketing
        title={ `${ t('Review & Approval') }` }
        descriptionLineHeight='1.6'
        descriptionInMid
        marginTop='60'
        marginTopMob='90'
        alignLeft
        imgOnLeft
        noExtraMarginTop
        contentMarginTop='10'
        headingMarginBottom='10'
        descriptionFontSize='12'
        imgSrc={ Advantage04_1x }
        srcSet={ `${ Advantage04_1x } 1x, ${ Advantage04_2x } 2x, ${ Advantage04_3x } 3x` }
        description={ t(
          'You can validate and approve potential guests who RSVP to your events before sending tickets to them. Keep track on your attendee list and deliver consistent responses.'
        ) }
      />

      <RegistrationAndTicketing
        title={ `${ t('Customized badges for guests') }` }
        descriptionLineHeight='1.6'
        descriptionInMid
        marginTop='60'
        marginTopMob='90'
        alignRight
        noExtraMarginTop
        contentMarginTop='10'
        headingMarginBottom='10'
        descriptionFontSize='12'
        imgSrc={ Advantage05_1x }
        descriptionWidth='420px'
        descriptionWidthMob='100%'
        srcSet={ `${ Advantage05_1x } 1x, ${ Advantage05_2x } 2x, ${ Advantage05_3x } 3x` }
        description={ t(
          'Automatically create ready-to-print customized badges for guests that can serve as tickets and identification for any event. Know more about your guests effortlessly with our template RSVP and registration forms.'
        ) }
      />
    </SectionWrapper>
    <SectionWrapper
      paddingTop='73'
      paddingBottomMob='90'
      customPaddingBottom='0'
    >
      <SectionHeading fontSizeMob='20'>
        { t('Engage with your community before and after the event') }
      </SectionHeading>
      <RegistrationAndTicketing
        noExtraMarginTop
        description={ t(
          'Enhance your pre and post event engagement by reviewing and analyzing real-time reports. Track your events in real time to get meaningful insights through detailed analytics. All this to organize better events and long-term membership engagement.'
        ) }
        ImgSpacingOnRight='5%'
        descriptionLineHeight='1.6'
        marginLeft='20px'
        descriptionInMid
        marginTopMob='30'
        contentMarginTop='10'
        headingMarginBottom='10'
        descriptionFontSize='12'
        imgSrc={ statisticsImg }
        srcSet={ `${ statisticsImg3X } 3x, ${ statisticsImg2X } 2x, ${ statisticsImg } 1x` }
        title={ t('Get the bigger picture') }
      />
      <RegistrationAndTicketing
        description={ t(
          'Collate all your contacts into one email marketing system to drive engagement. Create your own email templates with different functions and fields, send them off right away.'
        ) }
        descriptionLineHeight='1.6'
        alignLeft
        imgOnLeft
        descriptionInMid
        marginTop='90'
        marginTopMob='90'
        noExtraMarginTop
        contentMarginTop='10'
        headingMarginBottom='10'
        descriptionFontSize='12'
        imgSrc={ dragAndDropEmailImg }
        srcSet={ `${ dragAndDropEmailImg3X } 3x, ${ dragAndDropEmailImg2X } 2x, ${ dragAndDropEmailImg } 1x` }
        title={ t('Reduce repetitive email tasks') }
      />
      <RegistrationAndTicketing
        description={ t(
          'Faster responses and reaction on critical issues, always engage with your members to gather information and get feedbacks. Our easy-to-use form builder tools help you create any kind of surveys and forms.'
        ) }
        ImgSpacingOnRight='5%'
        descriptionLineHeight='1.6'
        marginLeft='20px'
        descriptionInMid
        marginTop='90'
        marginTopMob='90'
        noExtraMarginTop
        contentMarginTop='10'
        headingMarginBottom='10'
        descriptionFontSize='12'
        imgSrc={ dragAndDropFormImg }
        srcSet={ `${ dragAndDropFormImg3X } 3x, ${ dragAndDropFormImg2X } 2x, ${ dragAndDropFormImg } 1x` }
        title={ t('Build positive relationship') }
      />
      <RegistrationAndTicketing
        description={ t(
          'See everything you need in anytime, anywhere. Simplify your team\'s event management tasks, shorten guests\' waiting time, support membership service, improve the overall satisfaction in event organization and engagement.'
        ) }
        descriptionLineHeight='1.6'
        alignLeft
        imgOnLeft
        descriptionInMid
        marginTop='90'
        marginTopMob='90'
        noExtraMarginTop
        contentMarginTop='30'
        headingMarginBottom='10'
        descriptionFontSize='12'
        imgSrc={ mblApplicationImg }
        srcSet={ `${ mblApplicationImg3X } 3x, ${ mblApplicationImg2X } 2x, ${ mblApplicationImg } 1x` }
        title={ t('On-the-go with Juven Manager App') }
      >
        <MblAppIconContainer>
          <MblAppIconWrapper
            href='https://itunes.apple.com/us/app/juven-manager-app/id1438847545'
            target='_blank'
            rel='noopener noreferrer'
            id='engagement_mobile_app_ios'
          >
            <AppImage src={ appleStoreSvg } />
          </MblAppIconWrapper>
          <MblAppIconWrapper
            href='https://play.google.com/store/apps/details?id=com.juven.juvenmanagerapp'
            target='_blank'
            rel='noopener noreferrer'
            id='engagement_mobile_app_android'
          >
            <AppImage
              src={ googleStoreImg }
              srcSet={ `${ googleStoreImg3X } 3x, ${ googleStoreImg2X } 2x, ${ googleStoreImg } 1x` }
            />
          </MblAppIconWrapper>
        </MblAppIconContainer>
      </RegistrationAndTicketing>
    </SectionWrapper>

    <SectionWrapper
      backgroundColor
      paddingTop='120'
      paddingBottomMob='90'
      paddingTopMob='60'
    >
      <Oval
        color='linear-gradient(to bottom, #9de6ff, #64c9ff)'
        width='360px'
        height='360px'
        right='-140px'
        top='-180px'
      />

      <EventPagePicture alt='Express Event Page' src={ EventPagePictureSVG } />

      <ProductIntroduce
        title={ t('Making beautiful event pages is easy!') }
        fontSizeWeb='25'
        fontSizeMob='20'
      />

      <RegistrationAndTicketing
        button={
          <Button
            margin='30px 0 0 0'
            marginMob='30px auto 60px'
            inverted
            href={ `${ GATSBY_MANAGER_URL }/signup` }
            id='events_create_events_now'
          >
            { t('Create event now') }
          </Button>
        }
        title={ `${ t('Express Event Page') }` }
        descriptionLineHeight='1.6'
        descriptionInMid
        marginTop='90'
        marginTopMob='60'
        alignRight
        noExtraMarginTop
        contentMarginTop='10'
        headingMarginBottom='10'
        descriptionFontSize='12'
        imgSrc={ Advantage03_1x }
        srcSet={ `${ Advantage03_1x } 1x, ${ Advantage03_2x } 2x, ${ Advantage03_3x } 3x` }
        description={ t(
          'Start with our express event page to create your event. Easy and straightforward to navigate, allowing everyone to see what’s on, what tickets are available, and who is the event organizers.'
        ) }
      />

      <SliderContainer hideOnSmallScreen>
        <ProductFeature
          title={ t('Tailor-made unique catalog page') }
          textWidth='60%'
          text={ t(
            'Your imagination is the limit. Our designers can help create stunning bespoke event pages, all while powered by Juven\'s robust technologies to suites all kinds of event organizations. These are available on a project basis.'
          ) }
          urls={ [
            'https://juven.co/detour2018',
            'https://juven.co/thistownneeds',
            'https://juven.co/themillshk'
          ] }
          imgSrcSet={ [
            { _1x: Slide01_1x, _2x: Slide01_2x, _3x: Slide01_3x },
            { _1x: Slide02_1x, _2x: Slide02_2x, _3x: Slide02_3x },
            { _1x: Slide03_1x, _2x: Slide03_2x, _3x: Slide03_3x }
          ] }
          carousel
          fullWidth
          arrows
          darken
        />
      </SliderContainer>

      <SliderContainer hideOnLargeScreen>
        <ProductFeature
          titleMarginTop='25px'
          titleMarginTopMob='20px'
          titleWidth='100%'
          title={ t('Tailor-made unique catalog page') }
          textMarginTopMob='10px'
          text={ t(
            'Your imagination is the limit. Our designers can help create stunning bespoke event pages, all while powered by Juven\'s robust technologies to suites all kinds of event organizations. These are available on a project basis.'
          ) }
          urls={ [
            'https://juven.co/detour2018',
            'https://juven.co/thistownneeds',
            'https://juven.co/themillshk'
          ] }
          imgSrcSet={ [
            { _1x: Slide01_1x, _2x: Slide01_2x, _3x: Slide01_3x },
            { _1x: Slide02_1x, _2x: Slide02_2x, _3x: Slide02_3x },
            { _1x: Slide03_1x, _2x: Slide03_2x, _3x: Slide03_3x }
          ] }
          carousel
          fullWidth
          centerPadding='10px'
          arrows
          darken
        />
      </SliderContainer>

      <Button
        margin='30px auto 0'
        inverted
        href='https://juven.co/contact'
        target='_blank'
        rel='noreferrer'
        id='events_contact_sales'
      >
        { t('Contact sales') }
      </Button>
    </SectionWrapper>

    <SectionWrapper paddingTop='120' paddingBottomMob='90' paddingTopMob='90'>
      <Oval
        color='linear-gradient(to bottom, #9de6ff, #64c9ff)'
        width='360px'
        height='360px'
        left='-140px'
        top='-90px'
      />

      <ProductIntroduce
        title={ t('Unlimited ticket sales for a flat fee') }
        titleMob={ t('Free, paid or recurring') }
        fontSizeWeb='25'
        fontSizeMob='20'
      />

      <ProductDescription
        width='645px'
        widthMob='90%'
        description={ t(
          'With the Juven Community Builder plan, there\'s no Juven transaction cost on ticketing or membership fees.'
        ) }
        descriptionMob={ t(
          'No matter how you charge your members, Juven can handle it. Our pricing is affordable and easy to understand.'
        ) }
      />

      <PaymentMethods
        image={ Feature02 }
        title={ t('Events Manager') }
        pricing={{ percent: 0 }}
        source='events'
      />
    </SectionWrapper>

    <GetStarted
      heading={ t('Creating events is easier than you think!') }
      buttonText={ t('Try it today') }
      url={ `${ GATSBY_MANAGER_URL }/signup` }
      source='events'
    />

    <SectionWrapper
      backgroundColor
      paddingTop='120'
      paddingTopMob='90'
      paddingBottomMob='60'
    >
      <SectionHeading fontSizeMob='20' paddingBottom='60' paddingBottomMob='30'>
        { t('Explore other features in Juven') }
      </SectionHeading>

      <FeatureList list={ FeatureListData } />
    </SectionWrapper>
  </Wrapper>
);



// WEBPACK FOOTER //
// ./src/pages/products/events.jsx